/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import {
  IAny,
  IRequestContext
} from '../../DashboardKPIWidgets/IEnergyManagementProps';
import { returnFormattedDate } from './Utils';

export const getConnctorConfig = (
  name: string,
  requestContext: IRequestContext,
  startTime?: string,
  endTime?: string,
  additionalOptions?: Record<string, string>
) => {
  const newStartTime = startTime ? startTime : requestContext.context.startTime;
  const newEndTime = endTime ? endTime : requestContext.context.endTime;
  return {
    name,
    options: {
      startDate: requestContext.context.startTime
        ? returnFormattedDate(newStartTime!)
        : '',
      endDate: requestContext.context.endTime
        ? returnFormattedDate(newEndTime!)
        : '',
      ...additionalOptions
    }
  };
};
const hstName = window.location.href;
const isMCDSSO = hstName.includes(window.ENV?.MCD_HOSTNAME);

export const getBearerTokenFromLS = () => {
  const sessionToken = getBearerTokenFromSS();
  if (sessionToken !== '') return sessionToken;
  else {
    const storedData = window.ENV
      ? localStorage.getItem(
          `oidc.user:${window.ENV.AUTHORITY}:${
            isMCDSSO ? window.ENV?.MCD_CLIENT_ID : window.ENV.CLIENT_ID
          }`
        )
      : '';
    let readLocalStorage = storedData ? JSON.parse(storedData) : '';
    if (readLocalStorage) return readLocalStorage.access_token;
    else return '';
  }
};

export const getBearerTokenFromSS = () => {
  const storedData = window.ENV
    ? sessionStorage.getItem(
        `oidc.user:${window.ENV.AUTHORITY}:${
          isMCDSSO ? window.ENV?.MCD_CLIENT_ID : window.ENV.CLIENT_ID
        }`
      )
    : '';
  let readSessionStorage = storedData ? JSON.parse(storedData) : '';
  if (readSessionStorage) return readSessionStorage.access_token;
  else return '';
};

declare global {
  interface Window {
    ENV: IAny;
  }
}
